module.exports = __webpack_public_path__ + "a4acd8387f50a665ef8c78e8e1f402cb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-1024.webp.png
// module id = 197
// module chunks = 0